import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import './styles/attendance.css';
import PrivateRoute from './PrivateRoute';
import { ToastContainer } from 'react-toastify';

const LoginBody = lazy(() => import('./components/LoginBody'));
const Dashboard = lazy(() => import('./components/Dashboard'));
const AllOrganization = lazy(() => import('./components/AllOrganization'));
const AddOrganization = lazy(() => import('./components/AddOrganization'));
const DetailsOrganization = lazy(() => import('./components/DetailsOrganization'));
const AllUser = lazy(() => import('./components/AllUser'));
const AddUser = lazy(() => import('./components/AddUser'));
const DetailsUser = lazy(() => import('./components/DetailsUser'));
const AllCompany = lazy(() => import('./components/AllCompany'));
const AddCompany = lazy(() => import('./components/AddCompany'));
const DetailsCompany = lazy(() => import('./components/DetailsCompany'));
const AllEmployee = lazy(() => import('./components/AllEmployee'));
const AllDraft = lazy(() => import('./components/AllDraft'));
const AddEmployee = lazy(() => import('./components/AddEmployee'));
const DetailsEmployee = lazy(() => import('./components/DetailsEmployee'));
const SettingDetails = lazy(() => import('./components/SettingDetails'));
const ForgotPassword = lazy(() => import('./components/ForgotPassword'));
const ResetPassword = lazy(() => import('./components/ResetPassword'));
const Attendance = lazy(() => import('./components/Attendance'));
const AttendanceRules = lazy(() => import('./components/AttendanceRules'));
const AttendanceMode = lazy(() => import('./components/AttendanceMode'));
const SalaryStructure = lazy(() => import('./components/SalaryStructure'));
const SalaryTemplates = lazy(() => import('./components/SalaryTemplates'));
const LoginOrganisationSet = lazy(() => import('./components/LoginOrganisationSet'));

const RouteLoading = () => <div className="text-center py-4">Loading...</div>;

function App() {
  return (
    <Router>
      <div>
        <ToastContainer />

        <Suspense fallback={<RouteLoading />}>
          <Routes>
            <Route path="/unauthorized" element={<h1>Access Denied</h1>} />
            <Route path="/" element={<LoginBody />} />
            <Route path="/set_organisation" element={<LoginOrganisationSet />} />

            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            

            <Route path="/dashboard"
                    element={
                        <PrivateRoute>
                            <Dashboard />
                        </PrivateRoute>
                    } /> 
            <Route path="/all-Organization"
                    element={
                        <PrivateRoute>
                            <AllOrganization />
                        </PrivateRoute>
                    } /> 
            <Route path="/add-organization"
                    element={
                        <PrivateRoute>
                            <AddOrganization mode="add" />
                        </PrivateRoute>
                    } />
            <Route path="/edit-organization/:organizationId"
                    element={
                        <PrivateRoute>
                            <AddOrganization mode="edit" />
                        </PrivateRoute>
                    } />
            <Route path="/details-organization/:organizationId"
                    element={
                        <PrivateRoute>
                            <DetailsOrganization />
                        </PrivateRoute>
                    } />

            <Route path="/all-User"
                    element={
                        <PrivateRoute>
                            <AllUser />
                        </PrivateRoute>
                    } /> 
            <Route path="/add-user"
                    element={
                        <PrivateRoute>
                            <AddUser mode="add" />
                        </PrivateRoute>
                    } />
            <Route path="/edit-user/:userId"
                    element={
                        <PrivateRoute>
                            <AddUser mode="edit" />
                        </PrivateRoute>
                    } />
            <Route path="/details-user/:userId"
                    element={
                        <PrivateRoute>
                            <DetailsUser />
                        </PrivateRoute>
                    } />
            <Route path="/all-company"
                    element={
                        <PrivateRoute>
                            <AllCompany />
                        </PrivateRoute>
                    } /> 
            <Route path="/add-company"
                    element={
                        <PrivateRoute>
                            <AddCompany mode="add" />
                        </PrivateRoute>
                    } />
            <Route path="/edit-company/:companyId"
                    element={
                        <PrivateRoute>
                            <AddCompany mode="edit" />
                        </PrivateRoute>
                    } />
            <Route path="/details-company/:companyId"
                    element={
                        <PrivateRoute>
                            <DetailsCompany />
                        </PrivateRoute>
                    } />

            <Route path="/all-employee"
                    element={
                        <PrivateRoute>
                            <AllEmployee />
                        </PrivateRoute>
                    } /> 
            <Route path="/all-draft"
                    element={
                        <PrivateRoute>
                            <AllDraft />
                        </PrivateRoute>
                    } /> 
            <Route path="/add-employee"
                    element={
                        <PrivateRoute>
                            <AddEmployee mode="add" />
                        </PrivateRoute>
                    } />
            <Route path="/edit-employee/:employeeId"
                    element={
                        <PrivateRoute>
                            <AddEmployee mode="edit" />
                        </PrivateRoute>
                    } />
            <Route path="/details-employee/:employeeId"
                    element={
                        <PrivateRoute>
                            <DetailsEmployee />
                        </PrivateRoute>
                    } />
            <Route path="/settings"
                    element={
                        <PrivateRoute>
                            <SettingDetails />
                        </PrivateRoute>
                    } />
            <Route path="/attendance"
                    element={
                        <PrivateRoute>
                            <Attendance />
                        </PrivateRoute>
                    } />
            <Route path="/attendance-rules"
                    element={
                        <PrivateRoute>
                            <AttendanceRules />
                        </PrivateRoute>
                    } />
            <Route path="/attendance-rules/late-entry"
                    element={
                        <PrivateRoute>
                            <AttendanceRules />
                        </PrivateRoute>
                    } />
            <Route path="/attendance-rules/late-entry/new"
                    element={
                        <PrivateRoute>
                            <AttendanceRules />
                        </PrivateRoute>
                    } />
            <Route path="/attendance-rules/early-exit"
                    element={
                        <PrivateRoute>
                            <AttendanceRules />
                        </PrivateRoute>
                    } />
            <Route path="/attendance-rules/early-exit/new"
                    element={
                        <PrivateRoute>
                            <AttendanceRules />
                        </PrivateRoute>
                    } />
            <Route path="/attendance-rules/overtime"
                    element={
                        <PrivateRoute>
                            <AttendanceRules />
                        </PrivateRoute>
                    } />
            <Route path="/attendance-rules/overtime/new"
                    element={
                        <PrivateRoute>
                            <AttendanceRules />
                        </PrivateRoute>
                    } />
            <Route path="/attendance-rules/leave"
                    element={
                        <PrivateRoute>
                            <AttendanceRules />
                        </PrivateRoute>
                    } />
            <Route path="/attendance-rules/leave/new"
                    element={
                        <PrivateRoute>
                            <AttendanceRules />
                        </PrivateRoute>
                    } />
            <Route path="/attendance-rules/holiday"
                    element={
                        <PrivateRoute>
                            <AttendanceRules />
                        </PrivateRoute>
                    } />
            <Route path="/attendance-rules/holiday/new"
                    element={
                        <PrivateRoute>
                            <AttendanceRules />
                        </PrivateRoute>
                    } />
            <Route path="/attendance-rules/weekly-off"
                    element={
                        <PrivateRoute>
                            <AttendanceRules />
                        </PrivateRoute>
                    } />
            <Route path="/attendance-rules/weekly-off/new"
                    element={
                        <PrivateRoute>
                            <AttendanceRules />
                        </PrivateRoute>
                    } />
            <Route path="/attendance-rules/brake-rules"
                    element={
                        <PrivateRoute>
                            <AttendanceRules />
                        </PrivateRoute>
                    } />
            <Route path="/attendance-mode"
                    element={
                        <PrivateRoute>
                            <AttendanceMode />
                        </PrivateRoute>
                    } />
            <Route path="/settings/attendance-mode"
                    element={
                        <PrivateRoute>
                            <AttendanceMode />
                        </PrivateRoute>
                    } />
            <Route path="/settings/attendance-mode/new"
                    element={
                        <PrivateRoute>
                            <AttendanceMode />
                        </PrivateRoute>
                    } />
            <Route path="/settings/salary-structure"
                    element={
                        <PrivateRoute>
                            <SalaryStructure />
                        </PrivateRoute>
                    } />
            <Route path="/settings/salary-templates"
                    element={
                        <PrivateRoute>
                            <SalaryTemplates />
                        </PrivateRoute>
                    } />
            <Route path="/settings/salary-templates/new"
                    element={
                        <PrivateRoute>
                            <SalaryTemplates />
                        </PrivateRoute>
                    } />
          </Routes>
        </Suspense>
      </div>
    </Router>
  );
}

export default App;
